import { render, staticRenderFns } from "./TimeLimitBanner.vue?vue&type=template&id=575f52b8&"
import script from "./TimeLimitBanner.vue?vue&type=script&lang=js&"
export * from "./TimeLimitBanner.vue?vue&type=script&lang=js&"
import style0 from "./TimeLimitBanner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports